<template>
  <div class="header">
    <div class="logo-box">
      <img class="logo" src="../../public/logo_kbmob@2x.png" alt="KBmob"/>
    </div>
    <div class="top-menu">
      <div v-if='curPage=="home"' class="top-menu-item menu-item-active">首页</div>
      <div v-else class="top-menu-item" @click="navTo('/', 'home')">首页</div>
      <div v-if='curPage=="advert"' class="top-menu-item menu-item-active">广告样式</div>
      <div v-else class="top-menu-item" @click="navTo('/advert')">广告样式</div>
<!--      <div v-if='curPage=="about"' class="top-menu-item menu-item-active">关于我们</div>-->
<!--      <div v-else class="top-menu-item" @click="navTo('/about')">关于我们</div>-->
    </div>
    <div class="right-menu">
      <div class="register-btn" @click="goUrl('https://admin.kuaibian.top/register')">立即注册</div>
      <div class="login-btn" @click="goUrl('https://admin.kuaibian.top')">登录</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['curPage'],
  data() {
    return {
      curPage:"home",
    }
  },
  methods: {
    navTo(url, page) {
      this.curPage = page;
      this.$router.push({path: url})
    },
    goUrl(url) {
      window.open(url);
    }
  }
}
</script>

<style lang="less">
.header {
  display: flex;
  height: 60px;
  background: #FFFFFF;
  border-bottom: 1px solid #e5e5e5;

  .logo-box {
    flex: 1;
    display: flex;
    align-items: center;

    .logo {
      margin-left: 40px;
      width: 120px;
      height: 20px;
    }
  }

  .top-menu {
    flex: 2;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;

    .top-menu-item {
      margin-right: 40px;
      cursor: pointer;
      padding: 5px 15px;
      border-radius: 4px;
      border: 1px solid #D8D8D8;
      color: #333333;
    }

    .menu-item-active {
      cursor: default;
      background-color: #10D294;
      color: #FFFFFF;
      font-weight: bold;
    }
  }

  .right-menu {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 40px;

    .register-btn {
      margin-right: 20px;
      cursor: pointer;
      padding: 5px 15px;
      border: 1px solid #D8D8D8;
      color: #333333;
      border-radius: 4px;
    }

    .login-btn {
      cursor: pointer;
      padding: 5px 15px;
      border: 1px solid #D8D8D8;
      color: #333333;
      border-radius: 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header-menu.vue